import {Controller} from '@hotwired/stimulus';
import {application} from 'src';
import {find, addClass, removeClass} from '@fretadao/f-js-dom';

application.register(
  'ratings',
  class extends Controller {
    static targets = ['suggestion'];
    static classes = ['hidden'];
    MINIMUM_RATE = 5;

    toggleSuggestion(event) {
      const isLowRating = parseInt(event.currentTarget.value) <= this.MINIMUM_RATE;

      if (isLowRating) {
        removeClass(this.suggestionTarget, this.hiddenClass);
        this.suggestionInput.setAttribute('required', true);
      } else {
        addClass(this.suggestionTarget, this.hiddenClass);
        this.suggestionInput.removeAttribute('required');
      }
    }

    get suggestionInput() {
      return find('textarea', this.suggestionTarget)
    }
  }
);
